





































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import DictAPI from '@/services/rest/bemob/dictionary';
import LoadingCircle from '@/components/loading-circle.vue'; 

@Component({
  components: {
    LoadingCircle
  }
})
export default class DeviceType extends Vue {
  @Prop() 
  conditions: any;

  @Prop() 
  target: any;

  loading: boolean = false;
  data: any[] = [];
  selected: any[] = [];
  predicate: string = 'EQUALS';

  @Watch('selected', {
    deep: true
  })
  onSelectedChanged(value: any, oldValue: any ) {
    this.$set(this.conditions.deviceType, 'values', value.filter((e: any) => e));
  }

  @Watch('predicate')
  onPredicateChanged(value: any, oldValue: any) {
    this.$set(this.conditions.deviceType, 'predicate', value)
  }

  @Watch('conditions', {
    immediate: true
  })
  onConditionsChanged(value: any, oldValue: any) {
    if(!value.deviceType) {
      this.$set(this.conditions, 'deviceType', {
        predicate:  'EQUALS',
        values: []
      });
    }
  }

  mounted() {
    this.loading = true;
    (new DictAPI()).get('device-types', {}).then((types: any) => {
      this.data = types.map((e: any) => e.name);
      if (this.conditions.deviceType) {
        this.predicate = this.conditions.deviceType.predicate || this.predicate;
        this.selected = this.data.map((e: any) => this.conditions.deviceType.values.indexOf(e) !== -1 && e) || new Array(types.length);
      } else {
        this.selected = new Array(types.length);
      }
      this.loading = false;
    })
  }
}
